import React, { FC, useEffect } from "react";
import { HourlyIntervalData } from "../../../interfaces/HourlyIntervalData";
import { DailyIntervalData } from "../../../interfaces/DailyIntervalData";
import { WeeklyIntervalData } from "../../../interfaces/WeeklyIntervalData";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import LoadingSpinner from "../../extras/LoadingSpinner";
import { format, parseISO } from 'date-fns';

interface IProps {
    data: HourlyIntervalData[] | DailyIntervalData[] | WeeklyIntervalData[] | undefined,
    units: string,
    type: string
};

const formatValue = (value:number)=> {
    const formatter = new Intl.NumberFormat('en-US',{notation:'compact',maximumFractionDigits: 1 })
    return formatter.format(value)
  }





const IntervalDataGraph:FC<IProps> = (props) => {
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';

    let tick_interval = 0
    if(props.type === 'hourly'){
        tick_interval = 3
    }

    useEffect(()=>{
        if (props.data){
            setLoaded(true)
        }
    },[props.data])

    const CustomTick = ({x,y,payload}:any)=>{
        return <g transform={`translate(${x},${y})`}>
            <text x={0} y={0} dy={16} textAnchor="end" fill={newUI ? "black":"white"} transform="rotate(-35)" >
            {props.type === 'hourly' ? new Date(payload.value).toLocaleString([],{hour:'2-digit',minute:'2-digit'}) : null}
            {props.type === 'daily' ? format(parseISO(payload.value.replace('Z', '')), 'M/d/yy') : null }
            {props.type === 'weekly' ? format(parseISO(payload.value.replace('Z', '')), 'M/d/yy') : null }
            </text>
        </g>
        }

    const CustomTooltip = ({ active, payload, label, dataKey }:any)=>{
    return <div style={{background:'white',border:'black solid 2px', padding:'5px'}}>
          {payload.map((entry:any, index:any) => (<div key={index}>
            <div style={{color:'black'}} >
              {entry.name === 'Actual' ? <>
              <div>{props.type === 'hourly' ? new Date(label).toLocaleString([],{hour:'2-digit',minute:'2-digit'}) : null }</div>
              <div>{props.type === 'daily' ? format(parseISO(label.replace('Z', '')), 'M/d/yy'): null }</div>
              <div>{props.type === 'weekly' ? `Week of ${format(parseISO(label.replace('Z', '')), 'M/d/yy')}` : null }</div>
              </> : null }
              {entry.name}: {formatValue(entry.value)}
            </div>
            </div>
          ))}
    </div>
  }

    
    return <div>
        {loaded ? (
            <ResponsiveContainer width="100%" height={400}>
                <LineChart
                    width={500}
                    height={400}
                    data={props.data}
                    margin={{
                        top: 5,
                        right: 5,
                        left: 15,
                        bottom: 30,
                    }}
        >
                    <CartesianGrid strokeDasharray="10 10" />
                    <XAxis tick={CustomTick} axisLine={true} interval={tick_interval} dataKey={props.type === 'hourly' ? 'hour' : props.type === 'daily' ? 'day' : props.type === 'weekly' ? 'week' : ''} />
                    <YAxis tickFormatter={formatValue} tick={{fill:newUI ? "black":"white"}} axisLine={false} label={{ value: props.units, angle: -90, position: 'insideLeft' }}/>
                    <Tooltip content={CustomTooltip}/>
                    <Legend verticalAlign="top" align="center" height={36} />
                    <Line type="monotone" dataKey="value" name="Actual" strokeWidth={3} stroke="#01e8ff" />
                    <Line type="monotone" dataKey="baseline" name="Baseline" strokeWidth={3} stroke="#FFA500" />
                    <Line type="monotone" dataKey="model" name="Model" strokeWidth={3} stroke="#FF007F" />

                    
                    </LineChart>
            </ResponsiveContainer>)
            : <LoadingSpinner/>
        }
    </div>
};

export default IntervalDataGraph;